export const getBaseLineData = (baseLine: Record<string, any>, metricList: string[]) => {
  let baselineInfo;
  for (let i = 0; i < metricList.length; i++) {
    const metricKey = metricList[i];
    if (baseLine[metricKey]) {
      baselineInfo = baseLine[metricKey];
      break;
    }
  }
  return {
    custom: baselineInfo?.custom || '',
    conviva: baselineInfo?.conviva || '',
    isCustomSelected: baselineInfo?.isCustomSelected || false,
  };
};
